<div *ngIf="!loading">
    <div *ngIf="paymentSuccess">Redirecting to website..</div>
    <div *ngIf="!paymentSuccess">Something went wrong</div>
</div>